import { ParagraphSmall } from 'baseui/typography';
import { BasePageLayout } from './Page/BasePageLayout';

export interface PageProps {
    header: string,
    subheader?: string | null,
    children?: any
    actionButton?: any,
    showNavigateBack?: boolean | undefined,
    bottomButtons?: React.ReactNode[] | React.ReactNode | undefined
}


export const Page = (props: PageProps) => {

    return ( <BasePageLayout bottomActionButtons={props.bottomButtons} children={props.children} header={props.header} subheader={<ParagraphSmall margin={0}>{props.subheader}</ParagraphSmall>} actionButton={props.actionButton} showNavigateBack={props.showNavigateBack}></BasePageLayout>
    )
}
